import * as React                  from 'react'
import { Redirect, Route, Switch } from 'react-router'

import { LandingHeader }  from '../molecules'
import ForgotPassword     from '../organisms/ForgotPassword'
import ForgotPasswordSent from '../organisms/ForgotPasswordSent'
import ResetPassword      from '../organisms/ResetPassword'
import SlideShow          from '../organisms/SlideShow'
import {
  NotAuthenticatedCredentialsWrapper,
  NotAuthenticatedWrapper,
}                         from '../templates'
import LoginArea          from './LoginArea'
import RegisterArea       from './RegisterArea'

const images = [
  'https://cdn.discordapp.com/attachments/398422768984653826/484309767657881602/7-bkg_main_image.jpg',
  'https://cdn.discordapp.com/attachments/398422768984653826/484309771072045066/9-bkg_main_image.jpg',
  'https://cdn.discordapp.com/attachments/398422768984653826/484309765514592257/5-bkg_main_image.jpg',
  'https://cdn.discordapp.com/attachments/398422768984653826/484309763581149194/4-bkg_main_image.jpg',
  'https://cdn.discordapp.com/attachments/398422768984653826/484309762096234496/3a-bkg_main_image.jpg',
  'https://cdn.discordapp.com/attachments/398422768984653826/484309758921146369/1-bkg_main_image.jpg',
]

const NotAuthenticatedCredentialsArea = () => (
  <NotAuthenticatedCredentialsWrapper>
    <Switch>
      <Route path={'/'} exact component={LoginArea} />
      <Route path={'/forgot-password'} component={ForgotPassword} />
      <Route path={'/forgot-password-sent'} component={ForgotPasswordSent} />
      <Route path={'/reset-password/:token'} component={ResetPassword} />
      <Route component={() => <Redirect to={'/'} />} />
    </Switch>
  </NotAuthenticatedCredentialsWrapper>
)

const NotAuthenticated = () => {
  return (
    <SlideShow images={images}>
      <LandingHeader />
      <NotAuthenticatedWrapper>
        <Switch>
          <Route path={'/registration'} component={RegisterArea} />
          <Route component={NotAuthenticatedCredentialsArea} />
        </Switch>
      </NotAuthenticatedWrapper>
    </SlideShow>
  )
}

export default NotAuthenticated



// WEBPACK FOOTER //
// ./src/components/environments/NotAuthenticated.tsx